import React from "react";
import Slider from "react-slick";
import "./FeaturedThisWeekView.css";

const FeaturedThisWeekView = ({ data }) => {
  function SampleNextArrow(props) {
    const { className, style, onClick } = props;
    return (
      <div
        className={className}
        style={{ ...style, display: "none" }}
        onClick={onClick}
      />
    );
  }

  function SamplePrevArrow(props) {
    const { className, style, onClick } = props;
    return (
      <div
        className={className}
        style={{ ...style, display: "none" }}
        onClick={onClick}
      />
    );
  }

  const settings = {
    infinite: false,
    speed: 500,
    slidesToShow: 5,
    slidesToScroll: 2,
    autoplay: false,
    pauseOnHover: true,
    nextArrow: <SampleNextArrow />,
    prevArrow: <SamplePrevArrow />,
    responsive: [
      {
        breakpoint: 1200,
        settings: { slidesToShow: 4, slidesToScroll: 2 },
      },
      {
        breakpoint: 900,
        settings: { slidesToShow: 3, slidesToScroll: 2 },
      },
      {
        breakpoint: 600,
        settings: { slidesToShow: 2, slidesToScroll: 1 },
      },
    ],
  };

  if (!data || data.length === 0) {
    return (
      <div className="ftw-empty">
        <span className="ftw-empty-icon">🌟</span>
        <p className="ftw-empty-text">No featured items added yet</p>
      </div>
    );
  }

  return (
    <div className="ftw-wrapper">
     
      <Slider {...settings}>
        {data.map((item, index) => (
          <div key={index} className="ftw-slide-wrap">
            <div className="ftw-card">
              <img
                src={item?.image__image || item?.image}
                alt={item?.name || "Featured"}
                className="ftw-card-img"
                onError={(e) => {
                  e.target.style.display = "none";
                }}
              />
            </div>
          </div>
        ))}
      </Slider>
    </div>
  );
};

export { FeaturedThisWeekView };
